import { render, staticRenderFns } from "./Manageskills.vue?vue&type=template&id=3ccf53cf&"
import script from "./Manageskills.vue?vue&type=script&lang=js&"
export * from "./Manageskills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports